import { AxiosRequestConfig } from 'axios';
/**
 * hasBearerToken was created to check for a bearer token to decide whether a user should see
 * unauthorized error messages. If a bearer token exists it means the user is logged in, and
 * should see unauthorized notifications (or any error notifications). If not they should not see
 * error messages unless they pertain to a failed login.
 * @param config @type {AxiosRequestConfig}
 * @returns {boolean}
 */
export const hasBearerToken = (config: AxiosRequestConfig) => {
  if (!config) return false;
  return config?.headers?.['Authorization'] !== 'Bearer ';
};
